function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M459,442.3H53c-29.3,0-53-23.7-53-53V230.4c0-29.3,23.7-53,53-53h406c29.3,0,53,23.7,53,53v158.9 C512,418.6,488.3,442.3,459,442.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50508A"
    },
    d: "M300.1,309.9c0,73.1-59.3,132.4-132.4,132.4S35.3,383,35.3,309.9s59.3-132.4,132.4-132.4 S300.1,236.7,300.1,309.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283238"
    },
    d: "M167.7,449.3c-76.9,0-139.4-62.5-139.4-139.4s62.5-139.4,139.4-139.4S307.1,233,307.1,309.9 S244.6,449.3,167.7,449.3z M167.7,184.5c-69.2,0-125.4,56.3-125.4,125.4s56.3,125.4,125.4,125.4S293.1,379,293.1,309.9 S236.9,184.5,167.7,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434C6D"
    },
    d: "M247.2,309.9c0,43.9-35.6,79.4-79.4,79.4s-79.5-35.6-79.5-79.4s35.6-79.4,79.4-79.4 S247.2,266,247.2,309.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7383BF"
    },
    d: "M167.7,396.3c-47.7,0-86.4-38.8-86.4-86.4s38.8-86.4,86.4-86.4s86.4,38.8,86.4,86.4 S215.4,396.3,167.7,396.3z M167.7,237.4c-39.9,0-72.4,32.5-72.4,72.4s32.5,72.4,72.4,72.4s72.4-32.5,72.4-72.4 S207.7,237.4,167.7,237.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M141.2,327.5c0,4.9-4,8.8-8.8,8.8c-4.9,0-8.8-4-8.8-8.8s4-8.8,8.8-8.8 C137.3,318.7,141.2,322.6,141.2,327.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M132.4,309.9c-4.9,0-8.8-3.9-8.8-8.8c0-19.5,15.8-35.3,35.3-35.3c4.9,0,8.8,3.9,8.8,8.8 s-3.9,8.8-8.8,8.8c-9.7,0-17.7,7.9-17.7,17.7C141.2,305.9,137.3,309.9,132.4,309.9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M459,442.3H344.3c0-39,31.6-70.6,70.6-70.6H512v17.7C512,418.6,488.3,442.3,459,442.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546A79"
    },
    d: "M467.9,415.8h-61.8c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8h61.8c4.9,0,8.8,3.9,8.8,8.8 C476.7,411.9,472.7,415.8,467.9,415.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M512,274.6h-35.3c-9.8,0-17.7-7.9-17.7-17.7c0-9.8,7.9-17.7,17.7-17.7H512V274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD342E"
    },
    d: "M406.1,336.3h-35.3c-9.7,0-17.7-7.9-17.7-17.7c0-9.7,7.9-17.7,17.7-17.7h35.3 c9.7,0,17.7,7.9,17.7,17.7C423.7,328.4,415.8,336.3,406.1,336.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M344.3,248.1c-4.9,0-8.8-3.9-8.8-8.8v-61.8c0-4.9,3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8v61.8 C353.1,244.1,349.2,248.1,344.3,248.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M379.6,230.4c-4.9,0-8.8-3.9-8.8-8.8v-44.1c0-4.9,3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8v44.1 C388.4,226.5,384.5,230.4,379.6,230.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M414.9,212.8c-4.9,0-8.8-3.9-8.8-8.8v-26.5c0-4.9,3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8v26.4 C423.7,208.8,419.8,212.8,414.9,212.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E2E3"
    },
    d: "M229.5,124.5c-4.9,0-8.8-3.9-8.8-8.8v-14l-15.1-15.1c-3.5-3.5-3.5-9,0-12.5s9-3.5,12.5,0l20.2,20.2 v21.3C238.3,120.5,234.4,124.5,229.5,124.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E2E3"
    },
    d: "M282.5,124.5c-4.9,0-8.8-3.9-8.8-8.8V94.3l20.2-20.2c3.5-3.5,9-3.5,12.5,0s3.5,9,0,12.5l-15.1,15.1 v14C291.3,120.5,287.4,124.5,282.5,124.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E2E3"
    },
    d: "M264.8,80.3h-17.7c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8h17.7c4.9,0,8.8,3.9,8.8,8.8 C273.7,76.4,269.7,80.3,264.8,80.3"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M191.2,115.7h129.6c9.4,0,18.4,3.7,25,10.3l5.8,5.8c6.6,6.6,15.6,10.3,25,10.3h29.5 c19.5,0,35.3,15.8,35.3,35.3H70.6c0-19.5,15.8-35.3,35.3-35.3h29.5c9.4,0,18.4-3.7,25-10.3l5.8-5.8 C172.8,119.4,181.8,115.7,191.2,115.7"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/digital.1fb7ad7955892fc8a5c85319d3a962ad.svg";
export { ForwardRef as ReactComponent };